import styles from "../styles/Footer.module.css"

function Footer() {
  return (
    <footer>
      <nav>
        <a href='https://tinytinybang.tistory.com/' target='blank'>Tistory</a> | 
        <a href='https://github.com/pear27' target='blank'>Github</a>
      </nav>
      <p>
        <span>저자 : pear27</span><br/>
        <span>이메일 : jinalks43@gmail.com</span><br/>
        <span>Copyright 2024. pear27. All Rights Reserved.</span>
      </p>
    </footer>
  );
}

export default Footer;
